import { makeStyles } from "@material-ui/core/styles";

export function useModalStyles() {
  const useStyles = makeStyles((theme) => ({
    title: {
      fontWeight: 500,
      display: "flex",
      alignItems: "center",
      gap: theme.spacing(1),
      borderBottom: `1px solid #eeee`,
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
    },
    content: {
      padding: "20px 16px",
    },
    icon: {
      color: "#fff",
      fontSize: theme.typography.pxToRem(24),
    },
    contentText: {
      marginTop: theme.spacing(1),
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 400,
      color: "#333333",
    },
    cancelButton: {
      color: theme.palette.primary.main,
      fontSize: theme.typography.pxToRem(14),
    },
    confirmButton: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
      minWidth: 100,
      position: "relative",
    },
    contentActions: {
      display: "flex",
      width: "100%",
      justifyContent: "flex-end",
      alignItems: "center",
      borderTop: "1px solid #eeee",
      paddingTop: 16,
      marginTop: 10,
      gap: 8,
    },
    form: {
      margin: "10px 0px",
    },
  }));

  const classes = useStyles();

  return {
    classes,
  };
}
